export function BlockHighlight({ bounds }: { bounds: [number, number, number, number] }) {
  const [x, y, width, height] = bounds;
  const scale = 0.64;

  return (
    <svg style={{ position: "absolute", inset: 0, pointerEvents: "none" }}>
      <rect
        x={x * scale}
        y={y * scale}
        width={width * scale}
        height={height * scale}
        fill="rgba(15,118,110,0.08)"
        stroke="#0f766e"
        strokeWidth={2}
        strokeDasharray="5 3"
      />
    </svg>
  );
}
